import * as types from './constants';

export const setIsLoading = isLoading => ({
  type: types.SET_IS_LOADING,
  isLoading
});

export const setIsEmailConfigLoading = isEmailConfigLoading => ({
  type: types.SET_IS_EMAIL_CONFIG_LOADING,
  isEmailConfigLoading
});

export const setSchedulingConfiguration = data => ({
  type: types.SET_SCHEDULING_CONFIGURATION,
  data
});

export const setEmailConfigurations = data => ({
  type: types.SET_EMAIL_CONFIGURATIONS,
  data
});

export const clearSchedulingConfiguration = () => ({
  type: types.CLEAR_SCHEDULING_CONFIGURATION
});